import React from 'react'
import { useGlobal } from '../utils/GlobalContext';

export default function TituloTabla({ indice_completo, nombre }) {

    const { globalState } = useGlobal()

    return (
        globalState && globalState.items.map((item, index) => {
            return (
                indice_completo === item.indice_completo && item.instancias.length > 0 &&
                <div key={index} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 8, marginBottom: 2 }}>
                    <h4 style={{ fontWeight: 'bold', margin: 0, fontSize: 16, lineHeight: 1.2 }}>{indice_completo} {nombre}</h4>
                </div>
            )
        })
    )
}